import React, { useState, useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Box,
  InputAdornment,
  IconButton,
  OutlinedInput,
  FormHelperText,
  Grid,
  Alert,
  Button,
  FormControl,
  Typography,
  TextField,
  InputLabel,
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../redux/store/Store";
import { forgotPasswordApi } from "../../redux/forgotPassword/API";
import { forgotPasswordDetails } from "../../redux/forgotPassword/Model";
import MWLoader from "../../component/MWLoader";
import MWTextField from "../../component/MWTextField";
import { jwtTokenApiCall } from "../../redux/jwtProviderLogIn/API";
import { JwtTokenAuthBody } from "../../redux/jwtProviderLogIn/Model";
import { providerLoginDetailsApiCall } from "../../redux/jwtProviderLogIn/providerLoginDetails/API";
import { LoginBody } from "../../redux/jwtProviderLogIn/providerLoginDetails/Model";

export default function Loginwithpasswordcomponent() {
  const dispatch = useDispatch();
  const apiAuthTokenValue = useSelector(
    (state: AppState) => state.apiAuthToken
  );
  const providerLoginDetailsResponse = useSelector(
    (state: AppState) => state.providerLoginDetailsRes
  );
  const forgotPassword = useSelector((state: AppState) => state.forgotPassword);
  const [proOrgId, setProOrgId] = useState("");
  const [errorProOrgId, setErrorProOrgId] = useState("");
  const [email, setEmail] = useState("");
  const [errormail, setErrorMail] = useState("");
  const [errorpassword, setErrorPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const history = useHistory();
  const [modalActive, setModalActive] = useState(false);
  const [supportEmail, setSupportEmail] = useState("");
  const [forgotpasswordRes, setForgotpasswordRes] = useState("");
  const [errorsupportemail, setErrorsupportemail] = useState("");
  const errorSupportemail = errorsupportemail ? (
    <Typography>{errorsupportemail}</Typography>
  ) : (
    ""
  );
  // new code
  interface State {
    password: string;
    showPassword: boolean;
  }
  const [password, setPass] = React.useState<State>({
    password: "",
    showPassword: false,
  });
  const keyDownEvent = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };
  const handleChange =
    (prop: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setPass({ ...password, [prop]: event.target.value });
    };

  const handleClickShowPassword = () => {
    setPass({ ...password, showPassword: !password.showPassword });
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };
  
  const errorProdMess = errorProOrgId ? <Typography>{errorProOrgId}</Typography> : "";
  const errorEmail = errormail ? <Typography>{errormail}</Typography> : "";

  const errorPassword = errorpassword ? (
    <Typography>{errorpassword}</Typography>
  ) : (
    ""
  );

  const closeBanner = () => {
    setError("");
  };

  const errorDiv = error ? (
    <Alert variant="standard" severity="error" onClose={() => closeBanner()}>
      <p>{error}</p>
    </Alert>
  ) : (
    ""
  );
  const loadingMarkup = isLoading ? <MWLoader /> : null;
  const body = {
    username: email.toLowerCase(),
    password: password.password,
  } as JwtTokenAuthBody;

  useEffect(() => {
    apiAuthTokenValue?.loading ? setIsLoading(true) : setIsLoading(false);
  }, [apiAuthTokenValue]);

  //handle button click of login form Tab-1
  const handleLogin = () => {
    if (proOrgId === "" && email === "" && password.password === "" ) {
      setErrorProOrgId("Please provide Provider Organization Id");
      setErrorMail("Please provide email");
      setErrorPassword("Please provide password");
      return;
    } else if (proOrgId === "") {
      setErrorProOrgId("Please provide Provider Organization Id");
      setErrorMail("");
      setErrorPassword("");
      return;
    } else if (email === "") {
      setErrorProOrgId("");
      setErrorMail("Please provide email");
      setErrorPassword("");
      return;
    } else if (password.password === "") {
      setErrorProOrgId("");
      setErrorMail("");
      setErrorPassword("Please provide password");
      return;
    } else {
      dispatch(jwtTokenApiCall(body));
    }
  };

  const [access, setToken] = useState("");
  useEffect(() => {
    if (apiAuthTokenValue?.loginRes?.access !== undefined) {
      setToken(apiAuthTokenValue?.loginRes?.access);
    }
  }, [apiAuthTokenValue]);

  useEffect(() => {
    if (access !== "") {
      dispatch(
        providerLoginDetailsApiCall({
          providerOrganizationUniqueId: proOrgId.toString(),
          access: access,
        } as LoginBody)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [access]);

  useEffect(() => {
    setIsLoading(providerLoginDetailsResponse?.loading);
    if (
      providerLoginDetailsResponse?.getProviderLoginDetailsRes?.user !==
      undefined
    ) {
      window.location.reload();
    }
    if (providerLoginDetailsResponse?.errorMsg !== "") {
      history.push("/signin");
      setError(providerLoginDetailsResponse?.errorMsg);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [providerLoginDetailsResponse]);

  // ******* forgot password section modal **********

  const forgetPwd = useCallback(
    () => setModalActive((modalActive) => !modalActive),
    []
  );

  const supportEmailBody = {
    email: supportEmail,
  } as forgotPasswordDetails;

  const forgetPasswordApicall = () => {
    if (supportEmail === "") {
      setErrorsupportemail("Please enter valid email id or phone number");
    } else if (
      new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(
        supportEmail
      ) === false
    ) {
      setErrorsupportemail("Invalid Email");
    } else {
      dispatch(forgotPasswordApi(supportEmailBody));
    }
  };

  useEffect(() => {
    if (forgotPassword?.forgotPasswordRes?.message !== undefined) {
      setForgotpasswordRes(forgotPassword?.forgotPasswordRes?.message);
    } else {
      setForgotpasswordRes(forgotPassword?.errRes);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forgotPassword]);

  const forgetPwdPopup = () => {
    setSupportEmail("");
    setForgotpasswordRes("");
    setModalActive((modalActive) => !modalActive);
  };
  const modalMarkup = (
    <Dialog open={modalActive} onClose={forgetPwdPopup}>
      <DialogTitle>
        <Typography>Forgot Password?</Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Enter your user account's verified email address and we will send you
          a password reset link.
        </DialogContentText>
        <TextField
          sx={{ my: 2 }}
          autoFocus
          margin="dense"
          size="small"
          fullWidth
          label={"Email or Phone No"}
          value={supportEmail}
          id="supportemail"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setSupportEmail(event.target.value);
            setErrorsupportemail("");
          }}
          helperText={
            errorSupportemail === ""
              ? "Please provide email or phone number"
              : errorSupportemail
          }
          error={errorSupportemail === "" ? false : true}
        />
        <Box>{forgotpasswordRes}</Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={forgetPwdPopup}>Cancel</Button>
        <Button variant="contained" onClick={forgetPasswordApicall}>
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );

  const actualPageMarkup = (
    <Box onKeyDown={keyDownEvent}>
      {loadingMarkup}
      <MWTextField
        fullWidth
        sx={{ mt: 2, mb: 1 }}
        error={errorProdMess === "" ? false : true}
        value={proOrgId}
        label={"Provider Organization Id"}
        placeholder="Pleace Enter Id"
        id="providerOrgID"
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setProOrgId(event.target.value);
          setErrorProOrgId("");
        }}
        size="small"
        helperText={
          errorProdMess === ""
            ? "Please provide provider organization Id"
            : errorProdMess
        }
      />
      <TextField
        fullWidth
        sx={{ my: 2 }}
        size="small"
        value={email}
        error={errorEmail === "" ? false : true}
        label={"Provider Organization Email"}
        placeholder={"Enter your registered email"}
        id="emailFieldID"
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setEmail(event.target.value);
          setErrorMail("");
        }}
        helperText={errorEmail === "" ? "Please provide email" : errorEmail}
      />
      <FormControl fullWidth variant="outlined">
        <InputLabel size="small" htmlFor="outlined-adornment-password">
          Enter your password
        </InputLabel>
        <OutlinedInput
          id="outlined-adornment-password"
          size="small"
          error={errorPassword === "" ? false : true}
          placeholder={"Enter your password"}
          label={"Enter your password"}
          type={password.showPassword ? "text" : "Password"}
          value={password.password}
          onChange={handleChange("password")}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
                size="small"
              >
                {password.showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          }
        />
        <FormHelperText>
          <Grid
            container
            item
            direction="column"
            justifyContent="center"
            xs={12}
          >
            <Grid
              container
              item
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
            >
              <Box>
                {errorPassword === "" ? "Please enter password" : errorPassword}
              </Box>
              <Button size="small" color="primary" onClick={forgetPwd}>
                Forgot Password?
              </Button>
            </Grid>
          </Grid>
        </FormHelperText>
      </FormControl>
      <Button
        sx={{ my: 2 }}
        fullWidth
        variant="contained"
        color="primary"
        onClick={handleLogin}
      >
        Log In
      </Button>
      <div>{errorDiv}</div>
    </Box>
  );
  return (
    <div>
      {actualPageMarkup}
      {modalMarkup}
    </div>
  );
}
